<ap-button-link (click)="activateSkipLink($event)" variant="skip-link" data-testid="button">
    <ng-content></ng-content>
</ap-button-link>
